import {
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Td,
  Text,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import useFetchApi from "../../Hooks/useFetchApi";
import Loader from "../../components/Loader";
import TableView from "../../components/TableView";
import { FiEdit3, FiTrash2, FiEye } from "react-icons/fi";
import CustomPopup from "../../components/CustomPopup";
import ImageModal from "../../components/ImageModal";
import { toast } from "react-toastify";
import store from "../../redux/store";
import { delete_blog } from "../../redux/slice/BlogSlice";
import TableHeader from "../../components/TableHeader";
import useDebounce from "../../Hooks/useDebounce";
import useTableControls from "../../Hooks/useTableControls";
import useDeleteItem from "../../Hooks/useDeleteItem";
import HeadingLayout from "../../components/HeadingLayout";
import { base_url } from "../../utils/utils";

const Blog = () => {
  // States
  const {
    rows,
    setRows,
    page,
    setPage,
    search,
    setSearch,
    debouncedSearch,
    id,
    setId,
    url,
    setUrl,
  } = useTableControls();

  // Hooks
  const {
    data,
    isLoading,
    refetch: handleFetchData,
  } = useFetchApi({
    path: "blog.php",
    formDataArr: {
      action: "list",
      limit: rows,
      page: page,
      value: debouncedSearch,
    },
  });

  useEffect(() => {
    handleFetchData();
  }, [page, rows, debouncedSearch]);

  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isViewOpen,
    onClose: onViewClose,
    onOpen: onViewOpen,
  } = useDisclosure();

  const navigate = useNavigate();

  const { onDelete } = useDeleteItem(handleFetchData, delete_blog, id);

  // Function to truncate HTML content
  const truncateHTML = (html, maxLength) => {
    if (!html) return "";
    
    // Remove HTML tags and get plain text
    const text = html.replace(/<[^>]*>/g, "");
    
    // Truncate text and add ellipsis if needed
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  return (
    <Container h={"full"} w={"full"} maxW={"full"}>
      <HeadingLayout
        title={"Blog"}
        onClick={() => navigate("/add-blog", { state: { type: "Add" } })}
        totalCount={data?.totalCount}
      />

      {data?.totalCount > 0 && (
        <TableHeader
          filter={<></>}
          exprtData={false}
          placeholder={`Search Blog`}
          value={search}
          onSerchChange={(v) => {
            setPage(1);
            setRows(10);
            setSearch(v.target.value);
          }}
        />
      )}

      {isLoading && data?.data?.length === 0 ? (
        <Loader />
      ) : data?.data?.length === 0 ? (
        <Center bg={"#fff"} borderRadius={10}>
          <Image src="no-data.jpg" h={"md"} objectFit={"contain"} />
        </Center>
      ) : (
        <TableView
          pagination={true}
          initialValue={page * rows - rows + 1}
          rows={rows}
          page={page}
          onNext={() => {
            if (
              page <
              Math.ceil((search ? data?.searchCount : data?.totalCount) / rows)
            ) {
              setPage(page + 1);
            }
          }}
          onPrevious={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
          onChange={(e) => {
            setPage(1);
            setRows(e.target.value);
          }}
          total_value={search ? data?.searchCount : data?.totalCount}
          headData={[
            "S.No.",
            "Title",
            "Description",
            "Meta Description",
            "Image",
            "Alt Text",
            "Actions",
          ]}
          body={data?.data?.map((v, i) => (
            <Tr key={i}>
              <Td textAlign={"center"}>{i + 1 + rows * (page - 1)}</Td>
              <Td textAlign={"center"}>{v?.title}</Td>
              <Td textAlign={"center"} maxW="300px">
                <Text 
                  noOfLines={3} // This will show max 3 lines and then truncate with "..."
                  title={v?.description?.replace(/<[^>]*>/g, "")} // Show full text on hover
                >
                  {truncateHTML(v?.description, 100)}
                </Text>
              </Td>
              <Td textAlign={"center"} maxW="300px">
                <Text noOfLines={3} title={v?.meta_description}>
                  {v?.meta_description?.length > 100 
                    ? `${v?.meta_description.substring(0, 100)}...` 
                    : v?.meta_description}
                </Text>
              </Td>
              <Td
                minW={"200px"}
                textAlign={"center"}
                cursor={"pointer"}
                onClick={() => {
                  onViewOpen();
                  setUrl(base_url + v?.image);
                }}
              >
                <img width={"100px"} src={v?.image} alt={v?.alt_text} />
              </Td>
              <Td textAlign={"center"}>{v?.alt_text}</Td>
              <Td textAlign={"center"}>
                <Flex gap={3} justify={"center"}>
                  <FiEye
                    size={20}
                    cursor={"pointer"}
                    onClick={() => {
                      navigate("/blog-details", {
                        state: { blog: v },
                      });
                    }}
                  />
                  <FiTrash2
                    size={20}
                    cursor={"pointer"}
                    onClick={() => {
                      onOpen();
                      setId(v?.id);
                    }}
                  />
                  <FiEdit3
                    size={20}
                    cursor={"pointer"}
                    onClick={() => {
                      navigate("/add-blog", {
                        state: {
                          type: "Edit",
                          blogData: v 
                        },
                      });
                    }}
                  />
                </Flex>
              </Td>
            </Tr>
          ))}
        />
      )}

      <CustomPopup
        isOpen={isOpen}
        onClose={onClose}
        title={"Delete"}
        mess={"Are you sure? You want to delete Blog"}
        onClick={() => {
          onDelete();
          onClose();
        }}
      />
      <ImageModal
        isOpen={isViewOpen}
        onClose={onViewClose}
        url={url}
      />
    </Container>
  );
};

export default Blog;